import Img from 'gatsby-image'
import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Button from '../components/CustomButtons/Button.jsx'
import ErrorBoundary from '../components/ErrorBoundary'
import Hero from '../components/Hero'
import PostListing from '../components/PostListing/PostListing'

export default class Index extends Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges
    const pageEdges = this.props.data.page.edges[0]
    const pageData = pageEdges.node.frontmatter

    return (
      <Fragment>
        <Helmet title="Buy & Sell Bitcoin Using Canada's Best Bitcoin ATM Network" />
        <Hero ticker={pageData.ticker} />
        <IntroTextContainer>
          {pageData.intro &&
            pageData.intro.map(section => (
              <IntroTextGrid key={section.title}>
                <TitleBlock>
                  <h6>{section.supertitle}</h6>
                  <h2>{section.title}</h2>
                </TitleBlock>
                <IntroText
                  dangerouslySetInnerHTML={{
                    __html: section.body,
                  }}
                />
              </IntroTextGrid>
            ))}
        </IntroTextContainer>
        <TokenGrid>
          <TokenTextBlock>
            <BNCornerLogo
              src={pageData.token.logo.publicURL}
              alt="BitNational Logo"
            />
            <h6>{pageData.token.supertitle}</h6>
            <h1
              dangerouslySetInnerHTML={{
                __html: pageData.token.title,
              }}
            />
            <small>{pageData.token.subtitle}</small>
            <TokenCTA>
              <h5>{pageData.token.cta.supertitle}</h5>
              <h3>{pageData.token.cta.title}</h3>
              <Button
                href="https://exchange.bitnational.com/?register=true"
                color="primary"
                round
              >
                Get Now
              </Button>
            </TokenCTA>
          </TokenTextBlock>
          <TokenImage
            sizes={pageData.token.image.childImageSharp.sizes}
            alt="Two CryptoCurrency Traders on their smartphones"
          />
        </TokenGrid>
        <PublicationsSection>
          <h2>Publications</h2>
          <ErrorBoundary>
            <PostListing postEdges={postEdges} />
          </ErrorBoundary>
        </PublicationsSection>
      </Fragment>
    )
  }
}

const IntroTextContainer = styled.div``

const IntroTextGrid = styled.div`
  display: grid;
  grid-gap: ${p => p.theme.col()};
  grid-template-areas: 'title content';
  margin: ${p => p.theme.col(1.5)} auto;
  max-width: ${p => p.theme.col(16)};

  @media screen and (max-width: 768px) {
    grid-template-areas: 'title' 'content';
  }
`

const TitleBlock = styled.div`
  grid-area: title;
  width: ${p => p.theme.col(5)};
  h6,
  h2 {
    margin: 0;
    line-height: 1.15;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

const IntroText = styled.p`
  grid-area: content;
`

const TokenGrid = styled.div`
  display: grid;
  grid-template-areas: 'text image';
  width: ${p => p.theme.col(18)};
  margin-left: auto;
  overflow-x: hidden;

  @media screen and (max-width: 768px) {
    overflow: hidden;
    max-width: 100vw;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 100px;
    padding: 0 ${p => p.theme.col(1.5)};
  }
`

const TokenImage = styled(Img)`
  grid-area: image;
  width: ${p => p.theme.col(15)};
  z-index: -1;
  transform: translateX(-${p => p.theme.col(3)});

  @media screen and (max-width: 768px) {
    transform: translateX(-${p => p.theme.col(2)});
  }

  @media screen and (max-width: 480px) {
    transform: none;
  }
`

const BNCornerLogo = styled.img`
  width: ${p => p.theme.col()};
  opacity: 0.6;
  position: absolute;
  z-index: -1;
  transform: translateX(-65%) translateY(-40%);

  @media screen and (max-width: 768px) {
    width: 50px;
  }
`

const TokenTextBlock = styled.div`
  grid-area: text;
  position: relative;
  width: ${p => p.theme.col(8)};
  margin-top: ${p => p.theme.col(3)};
  padding-left: 100px;

  h6,
  h1 {
    margin: 0;
    line-height: 1.15;
  }

  @media screen and (max-width: 768px) {
    width: 95%;
  }

  @media screen and (max-width: 480px) {
    width: 130%;
    padding-left: 50px;
  }
`

const PublicationsSection = styled.div`
  max-width: ${p => p.theme.col(16)};
  margin: 0 auto;

  > div {
    margin: 0 auto;
  }

  @media screen and (max-width: 1440px) {
    max-width: ${p => p.theme.col(22)};
  }

  @media screen and (max-width: 768px) {
    max-width: ${p => p.theme.col(22)};
    h2 {
      max-width: ${p => p.theme.col(22)};
      margin: 0 auto;
    }
  }
`

const TokenCTA = styled.div`
  margin-top: ${p => p.theme.col(2)};

  h3 {
    margin: 0;
    margin-bottom: 2rem;
    max-width: 300px;
    line-height: 1.15;
    color: black;
  }
`

/* eslint no-undef: "off" */
export const IndexQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 3
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { key: { eq: "publication" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            cover {
              childImageSharp {
                resolutions(width: 400, height: 235) {
                  ...GatsbyImageSharpResolutions_withWebp
                }
              }
            }
            category
          }
        }
      }
    }
    page: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "home-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            ticker {
              symbol
              image {
                publicURL
              }
            }
            intro {
              supertitle
              title
              body
            }
            token {
              supertitle
              title
              subtitle
              logo {
                publicURL
              }
              image {
                childImageSharp {
                  sizes(maxWidth: 1200, quality: 100, cropFocus: ATTENTION) {
                    ...GatsbyImageSharpSizes_withWebp
                  }
                }
              }
              cta {
                supertitle
                title
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.jsx